<template>
    <b-container class="mt-4">
        <router-link
            :to="{ name: 'my_account' }"
        >&larr; Back</router-link>
        <h3>Account Activity</h3>
        <b-table
            striped
            bordered
            :items="activity"
            :busy="loading"
            class="mt-4"
            show-empty
        >
            <template #cell(OS)="data">
                <font-awesome-icon :icon="data.value.icon" class="mr-2"></font-awesome-icon>
                <b>
                    {{ data.value.name }} {{ data.value.version }}
                </b>
            </template>
            <template #empty>
                <b-alert :show="true" variant="info" class="mt-3">
                    <font-awesome-icon icon="info-circle" class="mr-2"></font-awesome-icon>
                    No account activity to display.
                </b-alert>
            </template>
        </b-table>
    </b-container>
</template>
<script>
import UAParser from 'ua-parser-js';

export default {
    mounted() {
        this.loading = true;
        this.$api.get("/api/account/activity").then((response) => {
            const data = response.data;
            this.activity = data.activity.map((timelog) => {
                var row     = { OS: "", device: "", browser: "", time: "" };
                const ua    = new UAParser(timelog.device_info);
                var result  = ua.getResult();
                if (!result.os.name) {
                    row.OS  = { name: "Unknown", icon: "question" };
                } else {
                    row.OS  = result.os;
                    var name = row.OS.name;
                    if (name == "Windows" || name == "Android" || name == "iOS" || name == "mac") {
                        if (name == "iOS" || name == "mac") {
                            name = "apple";
                        }
                    }
                    row.OS.icon = ["fab", name.toLowerCase()];
                }
                row.device  = result.device.model || "------";
                row.browser = result.browser.name || "------";

                row.time = this.$moment(timelog.logged_time).format("LLLL");
                return row;
            });
            this.loading = false;
        });
    },
    data() {
        return {
            loading: false,
            activity: []
        };
    }
}
</script>